import { ViewChildren, ViewContainerRef, QueryList, EventEmitter, ViewChild, ElementRef, ComponentFactoryResolver, Directive } from "@angular/core";
import { IButtonAction, IDetailComponent } from "../components/mf-blade/mf-blade.component";
import { Subscription } from "rxjs";
import { IBladeForm } from "../components/mf-blade-forms/mf-blade-forms.component";
import { SplitAreaDirective } from "angular-split";
import { IdentityAuthService } from "../../services/identity-auth/identity-auth.service";
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from "@angular/router";
import { BreadCrumbsService, BreadCrumb } from "../../services/bread-crumbs/bread-crumbs.service";
import { ApiService } from '@services/api/api.service';
import { NestedNavigationService } from "../../services/nested-navigation/nested-navigation.service";
import { IEntityOptions } from "../interfaces/IEntity";
import { MfPanelComponent } from "../components/mf-panel/mf-panel.component";
import { ToolbarActionsService } from "../../services/toolbar-actions/toolbar-actions.service";
import { IHeaderSetup, IBladeFormsSetup } from '../components/mf-panel-forms/mf-panel-forms.component';
@Directive()
export class FormRouteController {
  private formInstances: Array<any>;
  public hideForms: boolean = true;
  public saving: boolean;
  public loading: boolean;
  public switchBreadCrumbsWithoutNavigating = false;
  public entityOptions: IEntityOptions;
  protected forms: Array<IBladeForm>;
  private _subscriptions: Array<Subscription> = new Array<Subscription>();
  public get CurrentIndex() {
    return this.currentIndex;
  }
  public set CurrentIndex(value) {
    var _th = this;
    _th.breadCrumbService.navigating = true;
    //setTimeout(() => {


    _th.currentIndex = value;

    _th.minimiseExpandForms();

    if (_th.breadCrumbService.breadcrumbs)
      _th.breadCrumbService.breadcrumbs.forEach(o => {
        if (o.id == value)
          o.active = true;
        else o.active = false;
      })
    _th.toolbarActionService.selectedFormId = value;

    if (_th.formInstances) {
      _th.nestedNavigationService.setActions(_th.formInstances[value].hideSideMenu ? new Array() : _th.formInstances[value].menuItems, _th.toolbarActionService.route, _th.toolbarActionService.selectedFormId, _th.toolbarActionService.selectedNestedFormId);
    }
    //_th.breadCrumbService.navigating = false;
    //}, 1)

  }
  public currentIndex: number = 0;
  private _currentRouteParams: any;
  public get currentRouteParams() {
    return this._currentRouteParams;
  }
  public set currentRouteParams(value) {
    this._currentRouteParams = value;
    this.currentRouteParamsChange.emit(value);
    this.nestedNavigationService.currentRouteParams = value;
  }
  public currentRouteParamsChange = new EventEmitter();
  public saveClicked = new EventEmitter();
  public saveFinished = new EventEmitter();
  public canAddNew: boolean = false;
  public canSave: boolean = false;


  public minimiseExpandForms() {
    var _th = this;
    if (!_th.formInstances || _th.formInstances.length == 0)
      return;
    var formsToMinimise = this.formsToBuild.filter(function (o) {
      if ((typeof o.autoMinimise == 'undefined' || o.autoMinimise) && o.index < _th.currentIndex)
        return true;
      if (o.minimiseWhenLowerThanIndex < _th.currentIndex)
        return true;

      return false;
    });
    formsToMinimise.forEach(o => {
      if (_th.formInstances[o.index].minimise)
        _th.formInstances[o.index].minimise();
    })

    var formsToExpand = this.formsToBuild.filter(function (o) {
      if (o.minimiseWhenLowerThanIndex >= _th.currentIndex)
        return true;

      return false;
    });
    formsToExpand.forEach(o => {
      if (_th.formInstances[o.index].expandForm)
        _th.formInstances[o.index].expandForm();
    })
    if (this.formInstances[_th.currentIndex].expandForm)
      this.formInstances[_th.currentIndex].expandForm();
  }
  public calcSizeNum() {
    var _th = this;
    var currentlyVisible = this.formsToBuild.filter(function (o) {
      return _th.isBladeVisible(o)
    });
    var width = 0;
    currentlyVisible.forEach(o => {
      width += o.width
    });
    return width;
  }

  //public get formsToBuild(): Array<IBladeForm> { return this.forms };
  public formsToBuild: Array<IBladeForm> = new Array();

  @ViewChild('card', { static: true }) public card: ElementRef<any>;
  @ViewChild('breadCrumbActions', { static: true }) public breadCrumbActions: ViewContainerRef;
  @ViewChild('scrollContainer', { static: true }) public scrollContainer: ElementRef<any>;
  @ViewChild('test', { static: true }) public test: ElementRef<any>;


  @ViewChildren('formDetails', { read: ViewContainerRef }) public formDetails: QueryList<ViewContainerRef>;
  @ViewChildren('splitArea', { read: ViewContainerRef }) public splitArea: QueryList<SplitAreaDirective>;
  constructor(public ApiService: ApiService,
    public authService: IdentityAuthService,
    public router: Router,
    public route: ActivatedRoute,
    public componentFactoryResolver: ComponentFactoryResolver,
    public breadCrumbService: BreadCrumbsService,
    public nestedNavigationService: NestedNavigationService,
    public toolbarActionService?: ToolbarActionsService
  ) {
    this.ApiService = ApiService;
    this.authService = authService;
    this.router = router;
    this.route = route;
    this.componentFactoryResolver = componentFactoryResolver;
    this.breadCrumbService = breadCrumbService;
    this.breadCrumbService.onNavigateBack.subscribe(() => {
      this.navigateBackNested()
    });
    this.nestedNavigationService = nestedNavigationService;
    this.toolbarActionService = toolbarActionService;
  }

  //public ApiService: ApiService;
  //public authService: IdentityAuthService;
  //public router: Router;
  //public route: ActivatedRoute;
  //public componentFactoryResolver: ComponentFactoryResolver;
  //public breadCrumbService: BreadCrumbsService;
  //public nestedNavigationService: NestedNavigationService;
  //public toolbarActionService: ToolbarActionsService;


  ngOnInit() {

    var _th = this;
    this.route.data.subscribe(pa => {
      //Object.keys(pa).forEach(key => this.formsToBuild.push(pa[key]));
      var config = <IBladeFormsSetup>pa;
      this.forms = config.forms;
      this.formsToBuild = config.forms;
      this.switchBreadCrumbsWithoutNavigating = config.switchBreadCrumbsWithoutNavigating
      // this.nestedNavigationService.header = config.header;
      setTimeout(function () {
        _th.setForms();
      }, 1)

    });
    //this._subscriptions.push(this.router.events.subscribe(async event => {

    //  if (event instanceof NavigationStart) {
    //    this.loading = true;
    //    console.log('loading...');
    //  }
    //  if (event instanceof NavigationEnd) {
    //    setTimeout(() => {

    //      this.loading = false;
    //    },6000)
    //    console.log('loading complete');
    //  }
    //}))

    this._subscriptions.push(

      this.route.params.subscribe(
        params => {
          this.loading = true;
          var originalRoute = this.router.url

          if (originalRoute.indexOf(';') != -1) //strip out existing params
            originalRoute = originalRoute.substring(0, this.router.url.indexOf(';'));
          if (this.toolbarActionService.route != originalRoute)
            this.nestedNavigationService.setActions(new Array(), this.toolbarActionService.route, this.toolbarActionService.selectedFormId, this.toolbarActionService.selectedNestedFormId);
          this.toolbarActionService.route = originalRoute;

          this.currentRouteParams = params;
          let maxIndex = 0;
          Object.keys(this.currentRouteParams).forEach(key => {
            if (key.indexOf("id_") != -1) {
              let idIndex = parseInt(key.substring(3, key.length));
              let breadCrumbIndex = typeof _th.formsToBuild[idIndex].breadCrumbIndex == "undefined" ? idIndex : _th.formsToBuild[idIndex].breadCrumbIndex
              if (breadCrumbIndex > maxIndex)
                maxIndex = idIndex;
            }
          });
          this.CurrentIndex = maxIndex;
          this.buildBreadCrumbs();
          this.toolbarActionService.selectedFormId = this.CurrentIndex;
          if (this.formInstances && this.formInstances.length > 0)
            this.toolbarActionService.selectedNestedFormId = this.formInstances[this.CurrentIndex].selectedMenuItemIndex;
          this.toolbarActionService.setVisibleActions();

          this.setSelectedListItems();
          this.loading = false;
          setTimeout(() => {
            this.breadCrumbService.navigating = false;
          }, 10);
        }
      )
    );
  }

  public async ngAfterViewInit() {
    //if (this.formDetails && this.formDetails.length > 0) {
    //  await this.buildForms();
    //  this.minimiseExpandForms();
    //  this.setSelectedListItems();
    //}
  }
  public async setForms() {
    if (this.formDetails && this.formDetails.length > 0) {
      await this.buildForms();
      this.minimiseExpandForms();
      this.setSelectedListItems();
      this.buildBreadCrumbs();
    }
  }
  public addNewItem() {
    this.navigateNextNested(null);
  }


  private buildBreadCrumbs() {
    var self = this;
    if (!self.formInstances || self.formInstances.length == 0)
      return;
    this.formsToBuild.forEach(form => {
      if (self.isBladeVisible(form) && !form.noBreadcrumb) {
        this.breadCrumbService.breadcrumbs.push(new BreadCrumb({
          id: form.index,
          header: form.displayName,
          label: self.formInstances ? self.formInstances[form.index].headerIdentifier : null,
          command: function (item) {
            if (self.switchBreadCrumbsWithoutNavigating) {
              self.loading = false;
              self.breadCrumbService.navigating = false;
              self.CurrentIndex = form.index;
              self.breadCrumbService.breadcrumbs.forEach(o => {
                o.active = false;
              })
              item.active = true;
              self.toolbarActionService.selectedFormId = self.CurrentIndex;
              if (self.formInstances && self.formInstances.length > 0)
                self.toolbarActionService.selectedNestedFormId = self.formInstances[self.CurrentIndex].selectedMenuItemIndex;
              self.toolbarActionService.setVisibleActions();
            }
            else {
              self.loading = true;
              self.breadCrumbService.navigating = true;
              self.navigateBackToIndexv2((form.breadCrumbIndex ? form.breadCrumbIndex : (form.index + 1)))
            }
            //self.CurrentIndex = form.index;
            //self.breadCrumbService.breadcrumbs.forEach(o => {
            //  o.active = false;
            //})
            //item.active = true;
            //self.toolbarActionService.selectedFormId = self.CurrentIndex;
            //if (self.formInstances && self.formInstances.length > 0)
            //  self.toolbarActionService.selectedNestedFormId = self.formInstances[self.CurrentIndex].selectedMenuItemIndex;
            //self.toolbarActionService.setVisibleActions();
            setTimeout(function () {
              if (form.customAfterCommand)
                form.customAfterCommand(form, self);
            }, 1);
            if (self.switchBreadCrumbsWithoutNavigating)
              self.breadCrumbService.navigating = false;
          },
          active: self.CurrentIndex == form.index,
          sortOrder: typeof form.breadCrumbIndex == "undefined" ? form.index : form.breadCrumbIndex
        }));
      }
    })

  }

  private async buildForms() {
    this.loading = true;
    await this.authService.ensureAppSettingsLoaded();
    this.formInstances = new Array();
    for (let i = 0; i < this.formDetails.toArray().length; i++) {
      let component = this.formsToBuild[i];
      if (component) {
        let target = this.formDetails.toArray()[i];
        if (!component.component)
          component.component = MfPanelComponent;
        let widgetComponent = this.componentFactoryResolver.resolveComponentFactory(component.component);
        let componentRef: any = target.createComponent(widgetComponent);
        let _component: any = (componentRef.instance);
        _component.entity = component.component;
        _component.entity.component = _component;
        _component.parent = this;
        _component.formIndex = component.index;
        _component.displayName = component.displayName;
        _component.hideClose = component.hideClose;
        //if (component.entityOptions)
        // _component.entityOptions = Object.assign({}, component.entityOptions);
        _component.entityOptions = component.entityOptions;
        _component.formOptions = component.formOptions;
        _component.gridOptions = component.gridOptions;
        _component.formOnly = component.formOnly;
        if (component.showOnlyIfIdInUrl) {
          //_component.loadOnlyOnEntity = true;
          if (_component.entityOptions)
            _component.entityOptions.loadOnlyOnEntity = true;
        }
        if (component.hideSideMenu) {
          if (_component.entityOptions) {
            {
              _component.hideSideMenu = true;
              _component.entityOptions.hideSideMenu = true;
            }
            if (_component.entityOptions.form) {
              _component.hideSideMenu = true;
              _component.entityOptions.form.hideSideMenu = true;
            }
          }
          if (_component.gridOptions) {
            _component.hideSideMenu = true;
            _component.gridOptions.hideSideMenu = true;
          }
          if (_component.formOptions) {
            _component.hideSideMenu = true;
            _component.formOptions.hideSideMenu = true;
          }
        }
        if (component.loadFormWithoutParams) {
          if (_component.entityOptions) {
            _component.hideSideMenu = true;
            _component.entityOptions.loadOnlyOnEntity = false;
          }
        }

        if (_component.load)
          _component.load();
        //_component.splitter = this.splitArea.toArray()[component.index].element;
        this.formInstances.push(_component);
      }
    }

    this.loading = false;
  }


  public navigateNextNested(id) {
    this.CurrentIndex += 1;
    let newRouteParams: any = {};
    Object.assign(newRouteParams, this.currentRouteParams);
    newRouteParams["id_" + this.CurrentIndex] = id;
    var originalRoute = this.router.url
    if (originalRoute.indexOf(';') != -1) //strip out existing params
      originalRoute = originalRoute.substring(0, this.router.url.indexOf(';'));
    this.router.navigate([originalRoute, newRouteParams]);
    if (this.formInstances && this.formInstances.length > 0) {

      this.toolbarActionService.selectedFormId = this.CurrentIndex;
      this.toolbarActionService.selectedNestedFormId = this.formInstances[this.CurrentIndex].selectedMenuItemIndex;
    }
  }

  public navigateBackNested(selectedMenuItemIndex?) {
    let newRouteParams: any = {};
    Object.assign(newRouteParams, this.currentRouteParams);
    delete newRouteParams["id_" + this.CurrentIndex];
    this.CurrentIndex -= 1;
    while (!this.isBladeVisible(this.forms[this.CurrentIndex]) && this.CurrentIndex > 0)
      this.CurrentIndex -= 1;
    var originalRoute = this.router.url
    if (originalRoute.indexOf(';') != -1) //strip out existing params
      originalRoute = originalRoute.substring(0, this.router.url.indexOf(';'));
    this.router.navigate([originalRoute, newRouteParams]);
    if (typeof selectedMenuItemIndex != "undefined") {
      this.formInstances[this.CurrentIndex].selectedMenuItemIndex = selectedMenuItemIndex;
      this.toolbarActionService.selectedNestedFormId = selectedMenuItemIndex;
    }
    else if (this.formInstances && this.formInstances.length > 0) {

      this.toolbarActionService.selectedFormId = this.CurrentIndex;
      this.toolbarActionService.selectedNestedFormId = this.formInstances[this.CurrentIndex].selectedMenuItemIndex;
    }
  }

  public navigateBackToIndex(curIndex) {
    let newRouteParams: any = {};
    Object.assign(newRouteParams, this.currentRouteParams);

    Object.keys(this.currentRouteParams).forEach(key => {
      if (key.indexOf("id_") != -1) {
        let idIndex = parseInt(key.substring(3, key.length));
        let breadCrumbIndex = typeof this.formsToBuild[idIndex].breadCrumbIndex == "undefined" ? idIndex : this.formsToBuild[idIndex].breadCrumbIndex
        if (breadCrumbIndex > curIndex)
          delete newRouteParams["id_" + idIndex];
      }
    });

    while (curIndex <= this.CurrentIndex) {
      delete newRouteParams["id_" + this.CurrentIndex];

      Object.keys(newRouteParams).filter((o) => {
        return o.indexOf("_" + this.CurrentIndex) == 0
      }).forEach(o => {
        delete newRouteParams[o];
      })

      this.CurrentIndex -= 1;
    }

    while (!this.isBladeVisible(this.forms[this.CurrentIndex]) && this.CurrentIndex > 0)
      this.CurrentIndex -= 1;
    var originalRoute = this.router.url
    if (originalRoute.indexOf(';') != -1) //strip out existing params
      originalRoute = originalRoute.substring(0, this.router.url.indexOf(';'));
    this.router.navigate([originalRoute, newRouteParams]);

    setTimeout(() => {
      if (this.formInstances && this.formInstances.length > 0) {
        this.toolbarActionService.selectedFormId = this.CurrentIndex;
        this.toolbarActionService.selectedNestedFormId = this.formInstances[this.CurrentIndex].selectedMenuItemIndex;
      }
    },100)
    

  }

  public navigateBackToIndexv2(curIndex) {
    let newRouteParams: any = {};
    Object.assign(newRouteParams, this.currentRouteParams);

    Object.keys(this.currentRouteParams).forEach(key => {
      if (key.indexOf("id_") != -1) {
        let idIndex = parseInt(key.substring(3, key.length));
        let breadCrumbIndex = typeof this.formsToBuild[idIndex].breadCrumbIndex == "undefined" ? idIndex : this.formsToBuild[idIndex].breadCrumbIndex
        if (breadCrumbIndex > curIndex)
          delete newRouteParams["id_" + idIndex];
      }
    });

    var ind = this.CurrentIndex;
    while (curIndex <= ind) {
      delete newRouteParams["id_" + this.CurrentIndex];
      Object.keys(newRouteParams).filter((o) => {
        return o.indexOf("_" + this.CurrentIndex) == 0
      }).forEach(o => {
        delete newRouteParams[o];
      })
      ind -= 1;
    }

    var originalRoute = this.router.url
    if (originalRoute.indexOf(';') != -1) //strip out existing params
      originalRoute = originalRoute.substring(0, this.router.url.indexOf(';'));
    this.router.navigate([originalRoute, newRouteParams]);



  }

  public navigateToIndex(newIndex, newId, startNavIndex?, extraParams?) {
    let newRouteParams: any = {};
    Object.assign(newRouteParams, this.currentRouteParams);

    let maxIndex = 0;
    Object.keys(this.currentRouteParams).forEach(key => {
      if (key.indexOf("id_") != -1) {
        let idIndex = parseInt(key.substring(3, key.length));
        let breadCrumbIndex = typeof this.formsToBuild[idIndex].breadCrumbIndex == "undefined" ? idIndex : this.formsToBuild[idIndex].breadCrumbIndex
        if (breadCrumbIndex > maxIndex)
          maxIndex = idIndex;
      }
    });

    while (startNavIndex < maxIndex) {
      delete newRouteParams["id_" + maxIndex];
      Object.keys(newRouteParams).filter((o) => {
        return o.indexOf("_" + maxIndex) == 0
      }).forEach(o => {
        delete newRouteParams[o];
      })
      maxIndex -= 1;
    }
    while (newIndex < this.currentIndex) {
      delete newRouteParams["id_" + this.currentIndex];
      this.CurrentIndex -= 1;
    }
    this.CurrentIndex = newIndex;
    newRouteParams["id_" + this.currentIndex] = newId;
    if (extraParams) {
      Object.keys(extraParams).forEach(o => {
        newRouteParams[o] = extraParams[o];
      })
    }
    var originalRoute = this.router.url
    if (originalRoute.indexOf(';') != -1) //strip out existing params
      originalRoute = originalRoute.substring(0, this.router.url.indexOf(';'));
    this.router.navigate([originalRoute, newRouteParams]);
    if (this.formInstances && this.formInstances.length > 0) {

      this.toolbarActionService.selectedFormId = this.CurrentIndex;
      this.toolbarActionService.selectedNestedFormId = this.formInstances[this.CurrentIndex].selectedMenuItemIndex;
    }
  }

  public navigateHome() {
    this.router.navigate(['/']);
  }

  private saveItem() {
    this.saveClicked.emit();
  }

  public isBladeVisible(form: IBladeForm) {
    if (typeof form.showOnlyIfIdInUrl != 'undefined' && form.showOnlyIfIdInUrl != false) {
      let isVisible = false;
      Object.keys(this.currentRouteParams).forEach(key => {
        if (key == "id_" + form.index) {
          isVisible = true;
        }
      });
      return isVisible;
    }
    if (this.currentRouteParams)
      return form.index <= this.currentIndex;
  }

  public isBladeVisibleOrMinimised(form: IBladeForm) {
    //if (form.showOnlyIfIdInUrl) {
    //  let isVisible = false;
    //  Object.keys(this.currentRouteParams).forEach(key => {
    //    if (key.indexOf("id_" + form.index) != -1) {
    //      isVisible = true;
    //    }
    //  });
    //  return isVisible;
    //}
    if (!this.formInstances)
      return false;
    if (this.formInstances.length - 1 < form.index)
      return false;
    if (this.formInstances[form.index].minimised)
      return false;
    if (this.currentRouteParams)
      return form.index <= this.currentIndex;
  }

  public getBladeByIndex(index: number) {
    return this.formInstances[index];
  }

  public refreshRelatedForms(entityName, entityId) {
    this.formInstances.forEach(o => {
      o.refreshForms(entityName, entityId)
    })
  }

  public refreshRelatedLists(entityName, entityId) {
    this.formInstances.forEach(o => {
      o.refreshLists(entityName, entityId)
    })

    this.nestedNavigationService.refreshRelatedListsTriggered.emit(entityName);
  }

  public refreshAllOpenForms(entityName, entityId) {
    var _th = this;
    if (_th.currentRouteParams && _th.formInstances && _th.formInstances.length > 0) {
      Object.keys(_th.currentRouteParams).forEach(key => {
        if (key.indexOf("id_") != -1) {
          let idIndex = parseInt(key.substring(3, key.length));
          if (_th.formInstances[idIndex].reload)
            _th.formInstances[idIndex].reload();
          else if (_th.formInstances[idIndex].load)
            _th.formInstances[idIndex].load();
        }
      });
    }
  }

  public setSelectedListItems() {
    let maxIndex = 0;
    var _th = this;
    if (_th.currentRouteParams && _th.formInstances && _th.formInstances.length > 0) {
      Object.keys(_th.currentRouteParams).forEach(key => {
        if (key.indexOf("id_") != -1) {
          let idIndex = parseInt(key.substring(3, key.length));
          let breadCrumbIndex = typeof this.formsToBuild[idIndex].breadCrumbIndex == "undefined" ? idIndex : this.formsToBuild[idIndex].breadCrumbIndex
          if (breadCrumbIndex > maxIndex)
            maxIndex = idIndex;
        }
      });
      for (var x = 0; x <= maxIndex; x++) {
        if (_th.formInstances[x + 1] && _th.formInstances[x + 1].entityOptions)
          if (_th.formInstances[x].setSelectedListItems)
            _th.formInstances[x].setSelectedListItems(_th.formInstances[x + 1].entityOptions.name, _th.currentRouteParams["id_" + (x + 1)])
      }
    }

  }

}
